import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import IconBoxContainer from "../containers/global/icon-box";
import NewsletterArea from "../containers/global/newsletter";
import TestimonialContainer from "../containers/global/testimonial";
import HomeAboutContainer from "../containers/home/about";
import MicrolearningContainer from "../containers/service/microlearning"
import LearningToolsContainer from "../containers/service/learning-tools";
import ShortContentContainer from "../containers/service/short-content";

import IntroContainer from "../containers/home/intro";
import ServiceListContainer from "../containers/service/service-list";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const HomePage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Lermo – Microlearning Platform" />
                <div className="wrapper">
                    <Header />
                    <IntroContainer />
                    <IconBoxContainer classOption="section-pb" />
                    <MicrolearningContainer />
                    <LearningToolsContainer />
                    <ShortContentContainer />
                    <ServiceListContainer />
                    {/* <HomeAboutContainer /> */}
                    {/* <TestimonialContainer />
                    <HomeAboutContainer />
                    <TestimonialContainer />
                    <HomeAboutContainer />
                     */}
                    <TestimonialContainer />
                    <NewsletterArea />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default HomePage;
